import React, { Component } from "react";
import PrivateRoute from "./core/PrivateRoute";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from './components/Login'
import Troca from './components/Troca'
import Termo from './components/Termo'
import Sucesso from "./components/Sucesso"
import Validacao from "./components/Validacao"
import ValidacaoEsqueciSenha from "./components/ValidacaoEsqueciSenha";
import EnvioSms from "./components/EnvioSms";
import ResetSenhaSucesso from "./components/ResetSenhaSucesso";

class App extends Component {

  render() {

    return ( 
          <BrowserRouter basename={process.env.PUBLIC_URL}>
              <Switch>
                  <Route exact path="/" component={Login} />
                  <Route exact path="/resetPassword" component={ValidacaoEsqueciSenha} />
                  <Route exact path="/resetPasswordSucess" component={ResetSenhaSucesso} />
                  <Route exact path="/envioSms" component={EnvioSms} />
                  <PrivateRoute path="/valid" component={Validacao} />
                  <PrivateRoute path="/termo" component={Termo} />
                  <PrivateRoute path="/troca" component={Troca} />
                  <PrivateRoute path="/sucesso" component={Sucesso} />
                  <Route path="*" component={() => <h1>Página não encontrada!</h1>} />
              </Switch>
          </BrowserRouter>
    );
  }
}

export default App;
  